module.exports = {"reviews":{"general":{"show_more":"Show More","ago":"ago","reviews":"Reviews"},"users":{"user_show":{"my_reviews":"My Reviews","count_reviews":"%{count} Reviews","seller_reviews":"%{name}'s Reviews","reviews_not_found":"There Are Currently No %{type}...","average_rating":"Average rating"},"show":{"reviewed_by":"Reviewed by","seller_feedback":"Seller's Feedback"}},"gigs":{"_inner_gig":{"drop_most_recent":"Most Recent","drop_positive":"Positive Reviews","drop_negative":"Negative Reviews"},"_rating":{"q1":"Seller Communication","q2":"Service as Described","q3":"Would Recommend"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/translations.en.json
// module id = eIBB
// module chunks = 0